'use strict';

const baseURL = window.location.hostname === 'localhost'
  ? 'http://localhost:3000/api/schedule'
  : `${process.env.API_URL}/schedule`;

export const schedule = (() => {
  const getSchedule = async () => {
    try {
      const response = await fetch(`${baseURL}`);
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }
      const scheduleData = await response.json();
      return scheduleData;
    } catch (error) {
      console.error('Error fetching schedule:', error);
      return [];
    }
  };

  const addEvent = async (newEvent) => {
    try {
      const response = await fetch(`${baseURL}/event`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newEvent),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }

      const result = await response.json();
      console.log('Event added:', result);
      return true;
    } catch (error) {
      console.error('Error adding event:', error);
      return false;
    }
  };

  const updateEvent = async (eventId, updatedEvent) => {
    try {
      const response = await fetch(`${baseURL}/event/${eventId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedEvent),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }

      const result = await response.json();
      console.log('Event updated:', result);
      return true;
    } catch (error) {
      console.error('Error updating event:', error);
      return false;
    }
  };

  const deleteEvent = async (eventId) => {
    try {
      const response = await fetch(`${baseURL}/event/${eventId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }

      console.log('Event deleted');
      return true;
    } catch (error) {
      console.error('Error deleting event:', error);
      return false;
    }
  };

  const addSubEvent = async (eventId, newSubEvent) => {
    try {
      const response = await fetch(`${baseURL}/event/${eventId}/subevent`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newSubEvent),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }

      const result = await response.json();
      console.log('Sub-event added:', result);
      return true;
    } catch (error) {
      console.error('Error adding sub-event:', error);
      return false;
    }
  };

  const updateSubEvent = async (eventId, subEventId, updatedSubEvent) => {
    try {
      const response = await fetch(`${baseURL}/event/${eventId}/subevent/${subEventId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedSubEvent),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }

      const result = await response.json();
      console.log('Sub-event updated:', result);
      return true;
    } catch (error) {
      console.error('Error updating sub-event:', error);
      return false;
    }
  };

  const deleteSubEvent = async (eventId, subEventId) => {
    try {
      const response = await fetch(`${baseURL}/event/${eventId}/subevent/${subEventId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }

      console.log('Sub-event deleted');
      return true;
    } catch (error) {
      console.error('Error deleting sub-event:', error);
      return false;
    }
  };

  return {
    getSchedule,
    addEvent,
    updateEvent,
    deleteEvent,
    addSubEvent,
    updateSubEvent,
    deleteSubEvent
  };
})();
